export default "__VITE_ASSET__2b6b0f7d__"